import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {Dashboard} from "../../../models/dashboard/Dashboard";
import {BaseComponent} from "../../BaseComponent";
import {DxTextBoxComponent, DxValidationGroupComponent} from "devextreme-angular";
import {DashboardService} from "../../../services/dashboard/dashboard.service";
import {DashboardWidget} from "../../../models/dashboard/DashboardWidget";
import {Widget} from "../../../models/dashboard/Widget";
import {GridsterConfig} from "angular-gridster2";

@Component({
  selector: 'app-dashboard-form',
  templateUrl: './dashboard-form.component.html',
  styleUrls: ['./dashboard-form.component.css', '../../common/dialog-style.css']
})
export class DashboardFormComponent extends BaseComponent implements OnInit {

  @ViewChildren('widgetForms') widgetForms!: QueryList<DxTextBoxComponent>;
  @ViewChild('validationGroupComponent') validationGroupComponent!: DxValidationGroupComponent;
  @Input('dashboard') newDashboard!: Dashboard;
  @Input('options') options!: GridsterConfig;
  @Output('closeDialog') closeDialog: EventEmitter<Dashboard> = new EventEmitter();

  public editMode: boolean = false;
  public isDashboardNameValid: boolean = true;

  protected dashboardWidgets: DashboardWidget[] = [];
  protected dashboardService: DashboardService = inject(DashboardService);
  protected loadingInfosForDialog = true;
  protected copiedDashboard?: Dashboard;
  protected copiedDashboardWidget?: DashboardWidget[];
  protected saveButtonOptions: any;

  /**
   * True if edited customer is valid and can be updated
   */

  customerEditTextOptions = {
    valueChangeEvent: 'keyup'
  };


  constructor() {
    super();

    const that = this;

    this.saveButtonOptions = {
      text: that.translate.instant('BUTTONS.SAVE'),
      icon: "save",
      stylingMode: "contained",
      type: "default",
      async onClick(_: any) {
        that.checkAndSaveDashboard();
      }

    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initializeData()
  }


  async initializeData() {

    if (this.isUpdate()) {
      this.dashboardService.getWidgetsOfSelectedDashboard().then((widgets) => {
        this.dashboardWidgets = widgets;
        this.copiedDashboardWidget = this.appService.deepCopy(this.dashboardWidgets)
      });
      this.copiedDashboard = this.appService.deepCopy(this.newDashboard);
    }

    this.loadingInfosForDialog = false;
  }

  doCloseDialog() {
    this.closeDialog.emit();
  }

  isUpdate() {
    return this.newDashboard.id !== undefined;
  }


  // /**
  //  * Check if Dashboard is valid, to enable SAVE button
  //  */
  // checkDashboardValidation() {
  //   const result = this.newDashboardForm.instance.validate();
  //   this.isDashboardFormValid = result.isValid && this.newDashboard!.name.replace(/\s/g, "").length > 0;
  //   this.editMode = true;
  // }

  addWidgetToList(wid: Widget) {
    const dw = new DashboardWidget(wid.name);
    // dw.id = this.getMaxBetweenListAndElement() + 1;
    dw.widgetId = wid.id;
    dw.name = this.translate.instant("WIDGETS.NAMES." + wid.name);
    dw.colsSize = wid.maxColsSize >= 2 ? 2 : 1;
    dw.rowsSize = wid.maxRowsSize >= 2 ? 2 : 1;

    if (this.newDashboard.id !== undefined
      && !!this.options
      && !!this.options.api
      && !!this.options!.api!.getFirstPossiblePosition) {
      const firstPossiblePosition = this.options!.api!.getFirstPossiblePosition({
        x: 0,
        y: 0,
        rows: wid.maxColsSize >= 2 ? 2 : 1,
        cols: wid.maxRowsSize >= 2 ? 2 : 1
      });

      dw.colsStart = firstPossiblePosition.x;
      dw.rowsStart = firstPossiblePosition.y;

    }

    this.editMode = true;
    this.dashboardWidgets.push(dw);
  }

  checkAndSaveDashboard() {

    if (!!this.newDashboard) {

      // VALIDATION
      if (!this.isDashboardNameValid) {
        return;
      }

      if (!this.validationGroupComponent.instance.validate().isValid) {
        return;
      }
      // PutDashboard
      this.dashboardService.putDashboard(this.newDashboard).then((id) => {
        // now saving dashboardWidgets if present
        this.newDashboard.id = id;
        this.saveDashboardWidgets(id)
          .then(() => {
          })
          .catch(() => {
          })
          .finally(() => {
            this.closeDialog.emit(this.newDashboard);
          })
      });
    }
  }

  revertDashboard() {
    if (this.copiedDashboard && this.copiedDashboardWidget) {
      this.newDashboard = this.appService.deepCopy(this.copiedDashboard);
      this.dashboardWidgets = this.appService.deepCopy(this.copiedDashboardWidget);
      this.editMode = false;
    }
  }

  saveDashboardWidgets(id: number) {
    let putWidgetCounter: number = 0;
    return new Promise(
      (resolve, reject) => {
        if (this.dashboardWidgets.length === 0) {
          resolve(true);
        }
        this.dashboardWidgets.forEach((w) => {
          this.dashboardService.putDashboardWidget(id, w)
            .then((dwId) => {
              w.id = dwId;
              this.newDashboard.id = id;
              putWidgetCounter++;
              if (putWidgetCounter >= this.dashboardWidgets.length) {
                resolve(true);
              }
            })
            .catch((error: any) => {
              reject(error);
            })
        });
      }
    )
  }

  isDashboardFormValid() {
    if (this.validationGroupComponent?.instance)
      return this.isDashboardNameValid && this.validationGroupComponent.instance.validate().isValid;
    return false;
  }

}
